exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/customer-list-reminder/customer-list-reminder.component.css
// module id = ../../../../../src/app/customer-list-reminder/customer-list-reminder.component.css
// module chunks = main